export const InfoBox = [
  {
    id:1,
    headline: "Fully Managed Communities By Tripvillas",
    img1: "https://d2vcelvjdj7n25.cloudfront.net/newhome/icons/housekeeper.svg",
    img2: "https://d2vcelvjdj7n25.cloudfront.net/newhome/icons/towel.svg",
    img3: "https://d2vcelvjdj7n25.cloudfront.net/newhome/icons/bed.svg",
    img4: "https://d2vcelvjdj7n25.cloudfront.net/newhome/icons/dinner.svg",
    text1: "High Quality housekeeping",
    text2: "Comfortable Linen and Toiletries",
    text3: "Quality Furniture & Fittings",
    text4: "Food Delivery Or Central Restaurant",
  },
];

export const ImageBox = [
  {
    id:2,
    headline1: "Sparsh Resort",
    subtext1: "Karjat, Maharashtra",
    headline2: "Lavasa",
    subtext2: "Lavasa, Maharashtra",
    headline3: "Tata Rio De Goa",
    subtext3: "Dabolim, Goa",
    headline4: "Puravankara Adora De Goa",
    subtext4: "Dabolim, Goa",
    headline5: "White Villas Shahapur",
    subtext5: "Shahapur, Maharasht",
    headline6: "White Villas Kasara",
    subtext6: "Kasara, Maharashtra",
    headline7: "Kenisha Holiday Homes",
    subtext7: "Pawasalwadi, Maharashtra",
    headline8: "Umiya Serene",
    subtext8: "Nerul, Go",
    headline9: "Oasis Alibaug",
    subtext9: "Alibag, Maharashtra",
    headline10: "Dreamz Shiroda",
    subtext10: "Shiroda, Maharashtra",
    headline11: "Pristine Bay Mahabalipuram",
    subtext11: "Thenpattinam, Tamil Nadu",
    headline12: "Ampelon Chikkaballapur",
    subtext12: "Chikkaballapur, Karnatak",
  },
];
